import L from 'leaflet';

export const ICLPark = new L.Icon({
    iconUrl: 'https://images.vexels.com/media/users/3/142675/isolated/preview/84e468a8fff79b66406ef13d3b8653e2-house-location-marker-icon-by-vexels.png',
    iconSize: [26, 26],
    popupAnchor: [0, -13]
})